export default "__VITE_ASSET__DyALnC5V__"